import React, { createContext, useContext, useState, useMemo, useEffect } from 'react'
import { darkTheme, lightTheme } from './theme'
import { lightColors } from '../utils/lightPalette'
import { darkColors } from '../utils/darkPalette'


const PaletteTheme = createContext()

export const PaletteThemeProvider = ({ children }) => {
    const [checked, setChecked] = useState(JSON.parse(localStorage.getItem("isDarkmode") ?? true))

    const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)")
    useEffect(() => {
        if(!localStorage.getItem("isDarkmode")){
            setChecked(darkThemeMq.matches)
        }
        return () => {}
     } ,[darkThemeMq])

    const handleChangeSwitch = () => {
        const state = !checked
        localStorage.setItem("isDarkmode", state)
        setChecked(state)
    }

    const theme = useMemo(() => checked ? darkTheme() : lightTheme(), [checked])
    const colors =  useMemo(() => checked ? darkColors : lightColors, [checked])

    return (
        <PaletteTheme.Provider value={{
            checked,
            handleChangeSwitch,
            colors,
            theme
        }}>
            { children}
        </PaletteTheme.Provider>
    )
}

export function usePaletteTheme() {
    return useContext(PaletteTheme)
}